/**
 * NewProcurement Page - Orchestrates the procurement wizard
 * Refactored: Logic moved to WizardContext, steps to individual components
 */
import Layout from '@/components/Layout';
import { useAuth } from '@/contexts/AuthContext';
import {
  WizardProvider,
  useWizard,
  WizardHeader,
  StepIntake,
  StepQuestions,
  StepAnswers,
  StepReview,
  StepLineItems,
  StepRfpPreview,
  StepRisk,
  WizardMasterReferenceSurfaces
} from '@/components/wizard';

// Step renderer component
const WizardSteps = () => {
  const { currentStep } = useWizard();

  // POSITIONAL AND INDEX-ALIGNED TO WIZARD_STEPS. This array is a
  // hand-maintained duplicate of the one in the other wizard page; nothing
  // used to assert that either of them matched WIZARD_STEPS, which is why
  // stepModel.parity.test.jsx now does. If you add or remove a step, three
  // places change together: WIZARD_STEPS, this array, and its twin.
  const steps = [
    <StepIntake key="intake" />,
    <StepQuestions key="questions" />,
    <StepAnswers key="answers" />,
    <StepReview key="review" />,
    <StepLineItems key="items" />,
    <StepRfpPreview key="rfp" />,
    <StepRisk key="risk" />
  ];

  return steps[currentStep] || null;
};

const NewProcurement = () => {
  // STALE QUOTA PANEL FIX (2026-07-28 ruling): NewProcurement sits under
  // AuthProvider (see App.js), so it's the natural place to hand
  // WizardProvider a live checkAuth reference - WizardContext itself
  // stays decoupled from AuthContext (see WizardContext.jsx's
  // onUsageChanged docstring).
  const { checkAuth } = useAuth();
  return (
    <WizardProvider onUsageChanged={checkAuth}>
      <Layout>
        <WizardHeader title="New Procurement" />
        {/* Item 3 (layout correction): trimmed left/right chrome padding -
            px-12/p-8 was leaving ~80px of dead margin on each side before a
            step's own max-w-* container even got a chance to reach its
            designed width on a typical laptop screen. Vertical padding is
            unchanged.
            UI CONSISTENCY (2026-07-27): max-w-6xl now lives HERE - the
            single choke point for step content width - instead of each
            step picking its own (max-w-3xl/4xl/6xl, or none at all), which
            made shared elements (RequirementContextCard, step banners)
            visibly resize/shift when moving between steps. 6xl is sized
            for the widest content, StepQuestions' two-column business/
            vendor layout - every step now renders at this SAME width;
            per-step wrappers are just `relative`, with no width/centering
            of their own (see wizardPageLayout.test.jsx). */}
        <div className="px-4 pb-6 md:px-8 md:pb-12 pt-6">
          <div className="bg-white border border-zinc-200 p-4 md:p-6 max-w-6xl mx-auto">
            {/* Staleness gate: advisory + risk fork, above every step. Same
                placement in ContinueProcurement.jsx - keep the two in sync. */}
            <WizardMasterReferenceSurfaces />
            <WizardSteps />
          </div>
        </div>
      </Layout>
    </WizardProvider>
  );
};

export default NewProcurement;
